import React, { useRef, useState } from "react";
import Compress from "browser-image-compression";
import showToast from "helpers/showToast";
import IconLoader from "components/IconLoader/IconLoader";
import AwsImage from "components/Files/AwsImage";
import { Image } from "react-bootstrap";
import { uploadFile, deleteFile } from "../../../../services/file-service";
import apiCall from "../../../../services/apiCall";

export default function SiteImageUpload({
  imageType,
  sha1Value,
  label,
  onUpdate,
  onDelete,
  thumb,
  containerClassName
}) {
  const inputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleEditClick = () => {
    inputRef.current.click();
  };

  const uploadImage = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setIsLoading(true);
    const options = {
      maxSizeMB: 1.5,
      useWebWorker: true,
      maxWidthOrHeight: 1280,
      initialQuality: 0.5
    };

    Compress(file, options)
      .then((compressedBlob) => {
        apiCall({
          service: uploadFile,
          serviceParams: {
            dosya: compressedBlob
          },
          onSuccess: (fileResponse) => {
            if (sha1Value) {
              apiCall({
                service: deleteFile,
                serviceParams: sha1Value
              });
            }

            onUpdate(imageType, fileResponse.data.dosyaSHA1);
            setIsLoading(false);
          },
          onError: () => {
            showToast("Görsel yüklenirken bir hata oluştu", { type: "error" });
            setIsLoading(false);
          }
        });
      })
      .catch((e) => {
        showToast("Görsel yüklenirken bir hata oluştu", { type: "error" });
        console.error("Image compression error:", e);
        setIsLoading(false);
      });

    event.target.value = null;
  };

  const removeUploadedImage = () => {
    onDelete(imageType);
  };

  return (
    <>
      <div className={`position-relative ${containerClassName || ""}`}>
        <h6 className="mb-0">{label}</h6>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="d-none"
          onChange={(event) => uploadImage(event)}
        />
        <button
          type="button"
          className="btn btn-white rounded-circle position-absolute text-muted shadow p-0"
          style={{ zIndex: 10, top: 0, right: -10, width: "26px", height: "26px" }}
          onClick={handleEditClick}
        >
          <IconLoader icon="mdiPencil" size={0.9} />
        </button>
        <div className="position-relative">
          {sha1Value ? (
            <AwsImage sha1={sha1Value} thumb={thumb} className={"rounded border w-100 h-100"} />
          ) : (
            <Image src={thumb} className={"rounded border w-100 h-100"} />
          )}
        </div>
        {sha1Value && (
          <button
            type="button"
            className="btn btn-white rounded-circle position-absolute text-muted shadow p-0"
            style={{ zIndex: 10, bottom: -10, right: -10, width: "26px", height: "26px" }}
            onClick={removeUploadedImage}
          >
            <IconLoader icon="mdiClose" size={0.9} />
          </button>
        )}
      </div>
      {isLoading && (
        <div
          className="position-absolute"
          style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 100 }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Yükleniyor...</span>
          </div>
        </div>
      )}
    </>
  );
}
